"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDebugModeEnabled = exports.isDebugModeSignaled = exports.disableDebugMode = exports.enableDebugMode = void 0;
const constants_1 = require("./constants");
const debugStyle = `
    [data-tbl-sl-updated],
    [data-tbl-sl-replaced],
    [data-tbl-sl-alternative] {
      outline: 3px solid blue !important;
      outline-offset: 6px !important;
    }

    [data-tbl-sl-replaced] {
      outline-color: green !important;
    }

    [data-tbl-sl-alternative] {
      outline-color: red !important;
    }

    .tbl-sl-debug-mode-merchant-list {
        padding: 10px 20px;
        border: 1px solid #ccc;
        background-color: #f9f9f9;
        border-radius: 5px;
        opacity: 0;
        position: fixed;
        top: 5px;
        left: 5px;
        z-index: 9999;
    }

    .tbl-sl-debug-mode-legend-list {
        position: fixed;
        top: 5px;
        right: 5px;
        z-index: 9999;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 10px 20px;
        opacity: 0.8;
    }

    .tbl-sl-debug-mode-legend-list ul {
        list-style: none;
        padding: 0;
    }

    .tbl-sl-debug-mode-legend-list ul li {
        margin: 5px 0;
        font-size: 14px
    }

    .tbl-sl-debug-mode-legend-list ul li span {
        display: inline-block;
        width: 17px;
        height: 17px;
        top: 4px;
        margin-right: 5px;
        position: relative;
        border-radius: 50%;
    }

    .tbl-sl-debug-mode-legend-list ul li span.red {
        background-color: red;
    }

    .tbl-sl-debug-mode-legend-list ul li span.green {
        background-color: green;
    }

    .tbl-sl-debug-mode-legend-list ul li span.blue {
        background-color: blue;
    }
`;
function enableDebugMode() {
    try {
        const style = document.createElement("style");
        const legend = document.createElement("div");
        style.id = constants_1.DEBUG_ID;
        style.innerHTML = debugStyle;
        document.head.appendChild(style);
        // Add a a html element, legend, with a list for colors that indicates the status of what happened to an element
        // red - alternative
        // green - replaced
        // blue - updated
        legend.className = "tbl-sl-debug-mode-legend-list";
        legend.innerHTML = `
        <ul>
          <li><span class="red"></span> Alternative</li>
          <li><span class="green"></span> Replaced</li>
          <li><span class="blue"></span> Updated</li>
        </ul>
      `;
        document.body.appendChild(legend);
    }
    catch (e) {
        console.log("Error using debug mode", e);
    }
}
exports.enableDebugMode = enableDebugMode;
function disableDebugMode() {
    const style = document.getElementById(constants_1.DEBUG_ID);
    if (style && style instanceof HTMLStyleElement) {
        style.remove();
    }
    const legend = document.querySelector(".tbl-sl-debug-mode-legend-list");
    if (legend) {
        legend.remove();
    }
}
exports.disableDebugMode = disableDebugMode;
const isDebugModeSignaled = () => {
    return window.location.search.includes(constants_1.DEBUG_QUERY);
};
exports.isDebugModeSignaled = isDebugModeSignaled;
function isDebugModeEnabled() {
    return document.getElementById(constants_1.DEBUG_ID) !== null;
}
exports.isDebugModeEnabled = isDebugModeEnabled;
